import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useApplicationNotifications } from '@adc/ui-adc'
import EventsActions from '../actions/events'
import CalendarResultsPanel from '../components/calendarResultsPanel'
import types from '../constants/propTypes'
import STATICS from '../statics'

const CalendarPanel = ({
  events,
  total,
  count,
  offset,
  fetchEventsAction,
  fetchEventsProgress = null,
  params,
}) => {
  const notifications = useApplicationNotifications()

  return (
    <CalendarResultsPanel
      events={events}
      total={total}
      count={count}
      offset={offset}
      fetchEventsAction={params =>
        fetchEventsAction(params).catch(e => {
          notifications.toast.open({
            title: STATICS.CALENDAR_ERROR_TITLE,
            message: STATICS.CALENDAR_ERROR_BODY,
            role: 'error',
          })
        })
      }
      fetchEventsProgress={fetchEventsProgress}
      params={params}
    />
  )
}

CalendarPanel.propTypes = {
  events: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  fetchEventsAction: PropTypes.func.isRequired,
  fetchEventsProgress: types.baseProgressType,
  params: types.params.isRequired,
}

function mapStateToProps(store) {
  return {
    events: store.events.events,
    total: store.events.total,
    count: store.events.count,
    offset: store.events.offset,
    fetchEventsProgress: store.events.fetchEventsProgress,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchEventsAction: params => dispatch(EventsActions.fetchEvents(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarPanel)
